module.exports = __webpack_public_path__ + "static/media/7.e8bd60aa.png";